import React, { createContext, useState, useContext, useEffect } from "react";

// Kept for backward compat with any direct colors usage
const lightColors = {
  primary: "#609BAB",
  secondary: "#E87E58",
  accent: "#6B7280",
  background: "#ffffff",
  text: "#1F2937",
  border: "#D1D5DB",
  hover: "#4F8699",
  active: "#547C8F",
};

const darkColors = {
  primary: "#609BAB",
  secondary: "#E87E58",
  accent: "#A1A1AA",
  background: "#1F2937",
  text: "#F9FAFB",
  border: "#4B5563",
  hover: "#4F8699",
  active: "#547C8F",
};

const ThemeContext = createContext(undefined);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("light");
  const [colors, setColors] = useState(lightColors);

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      setTheme(savedTheme);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("theme", theme);
    const nextColors = theme === "dark" ? darkColors : lightColors;
    setColors(nextColors);
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, colors }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
